import { render, staticRenderFns } from "./UserInformation.vue?vue&type=template&id=07a86e4a&scoped=true&"
import script from "./UserInformation.vue?vue&type=script&lang=ts&"
export * from "./UserInformation.vue?vue&type=script&lang=ts&"
import style0 from "./UserInformation.vue?vue&type=style&index=0&id=07a86e4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a86e4a",
  null
  
)

export default component.exports